import { createReducer, on } from '@ngrx/store';
import { Account } from 'src/app/models/account.model';
import { User } from 'src/app/models/user.model';
import { Dashboard } from '../../../models/dashboard.model';
import * as fromAccountsActions from '../../actions/accounts/accounts.actions';
import * as fromDashboardActions from '../../actions/dashboard/dashboard.actions';

export const dashboardFeatureKey = 'dashboard';

export interface State {
  dashboard: Dashboard | null;
  userDetails: User | null;
}

export const initialState: State = {
  dashboard: null,
  userDetails: null
};

export const reducer = createReducer(
  initialState,
  on(fromDashboardActions.loadDashboardDataSuccess, (state, action) => {
    return {
      ...state,
      dashboard: action.dashboard
    };
  }),
  on(fromAccountsActions.changeAccountName, (state, action) => {
    const accounts: Account[] | null = state.dashboard?.accounts
      ? state.dashboard.accounts.map(item => {
          return item.accountId === action.accountId
            ? (item = {
                ...item,
                accountName: action.accountName
              })
            : item;
        })
      : null;
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard,
            accounts: state.dashboard.accounts ? accounts : null
          }
        : null
    };
  }),
  on(fromAccountsActions.changeAccountActiveCurrency, (state, action) => {
    if (state.dashboard?.accounts) {
      const accountsArray = state.dashboard?.accounts.map(account => {
        if (account.accountId === action.accountId) {
          return {
            ...account,
            activeBalance: action.activeBalance
          };
        }
        return account;
      });
      return {
        ...state,
        dashboard: state.dashboard
          ? {
              ...state.dashboard,
              accounts: accountsArray
            }
          : null
      };
    }
    return {
      ...state
    };
  }),
  on(fromDashboardActions.resetAccountsToInitialState, (state, action) => {
    let accountsArray: Account[] = [];
    if (state.dashboard?.accounts) {
      accountsArray = state.dashboard.accounts?.map(item => {
        return {
          ...item,
          activeBalance: item.balances[0]
        };
      });
    }
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard,
            accounts: accountsArray
          }
        : null
    };
  }),
  on(fromDashboardActions.reduceUnreadMessages, (state, action) => {
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard,
            unreadMessageCount: action.unreadMessages
          }
        : null
    };
  }),
  on(fromDashboardActions.removeAccountsFromStore, (state, action) => {
    let accountsArray = null;
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard,
            accounts: accountsArray
          }
        : null
    };
  }),
  on(fromDashboardActions.loadDashboardDataSuccess, (state, action) => {
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard,
            purposeCode: action.dashboard?.purposeCodes
          }
        : null
    };
  }),
  on(fromDashboardActions.loadDashboardDataSuccess, (state, action) => {
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard
          }
        : null
    };
  }),
  on(fromDashboardActions.loadDashboardDataSuccess, (state, action) => {
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard,
            modelNumber: action.dashboard?.modelNumbers
          }
        : null
    };
  }),

  on(fromDashboardActions.loadDashboardDataSuccess, (state, action) => {
    return {
      ...state,
      dashboard: state.dashboard
        ? {
            ...state.dashboard,
            reference: action.dashboard?.references
          }
        : null
    };
  }),

  on(fromDashboardActions.loadUserDetailsSuccess, (state, { userDetails }) => ({
    ...state,
    userDetails
  })),

  on(fromDashboardActions.loadUserDetailsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);
